// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_mpsQty","footer":"ob_QNZ0Qg","toggleButtonWrapper":"ob_8NcZDf","footerExpanded":"ob_75EB0r"};